import { type AiLoadingState } from './aiLoadingMessages.const';
import { AiGeneratingPending } from './Base';
type Props = {
  query: string;
  loadingState: Omit<AiLoadingState, 'sourceType'>;
};
export const AiGeneratingPendingByQuery = ({
  query,
  loadingState
}: Props) => <AiGeneratingPending imageSrc={'/assets/ai_generating.gif'} prompt={query} loadingState={{
  ...loadingState,
  sourceType: 'query'
}} data-sentry-element="AiGeneratingPending" data-sentry-component="AiGeneratingPendingByQuery" data-sentry-source-file="AiGeneratingPendingByQuery.tsx" />;